import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gojs-view',
  templateUrl: './gojs-view.component.html',
  styleUrls: ['./gojs-view.component.css']
})
export class GojsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
